export const normalizeFormattedText = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  let normalized = String(value).replace(/\r\n?/g, '\n');

  // Some admin texts can come as escaped sequences (\\n, \\t).
  if (!normalized.includes('\n') && /\\[nrt]/.test(normalized)) {
    normalized = normalized
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\n')
      .replace(/\\t/g, '\t');
  }

  return normalized;
};
